"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  Location: () => Location
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native_nitro_modules = require("react-native-nitro-modules");
var import_nativeError = require("../nativeError");
var import_validation = require("./validation");
var hybrid;
function native() {
  hybrid !== null && hybrid !== void 0 ? hybrid : hybrid = import_react_native_nitro_modules.NitroModules.createHybridObject("OneLocation");
  return hybrid;
}
function getPermissionStatus() {
  try {
    return native().getPermissionStatus();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestWhenInUsePermission() {
  return native().requestWhenInUsePermission().catch(import_nativeError.rethrowNativeError);
}
function requestAlwaysAuthorization() {
  return native().requestAlwaysAuthorization().catch(import_nativeError.rethrowNativeError);
}
function getCurrentPosition() {
  return native().getCurrentPosition().catch(import_nativeError.rethrowNativeError);
}
function watchPosition(onPosition, onError) {
  var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  return native().addPositionListener(onPosition, function(code, message) {
    onError(Object.assign(new Error(message), {
      code
    }));
  }, options.background === true);
}
function geocodeAddress(address) {
  return native().geocodeAddress(address).catch(import_nativeError.rethrowNativeError);
}
function reverseGeocode(latitude, longitude) {
  return native().reverseGeocode(latitude, longitude).catch(import_nativeError.rethrowNativeError);
}
function startMonitoring(region) {
  (0, import_validation.assertRegion)(region, "startMonitoring");
  return native().startMonitoring(region).catch(import_nativeError.rethrowNativeError);
}
function stopMonitoring(identifier) {
  (0, import_validation.assertIdentifier)(identifier, "stopMonitoring");
  return native().stopMonitoring(identifier).catch(import_nativeError.rethrowNativeError);
}
function monitoredRegions() {
  try {
    return native().monitoredRegions();
  } catch (error) {
    return (0, import_nativeError.rethrowNativeError)(error);
  }
}
function requestState(identifier) {
  (0, import_validation.assertIdentifier)(identifier, "requestState");
  return native().requestState(identifier).catch(import_nativeError.rethrowNativeError);
}
function addDidEnterRegionListener(listener) {
  (0, import_validation.assertRegionListener)(listener, "addDidEnterRegionListener");
  var remove = native().addDidEnterRegionListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
function addDidExitRegionListener(listener) {
  (0, import_validation.assertRegionListener)(listener, "addDidExitRegionListener");
  var remove = native().addDidExitRegionListener(listener);
  return {
    remove: function remove1() {
      return remove();
    }
  };
}
var Location = Object.freeze({
  getPermissionStatus,
  requestWhenInUsePermission,
  requestAlwaysAuthorization,
  getCurrentPosition,
  watchPosition,
  geocodeAddress,
  reverseGeocode,
  startMonitoring,
  stopMonitoring,
  monitoredRegions,
  requestState,
  addDidEnterRegionListener,
  addDidExitRegionListener
});
//# sourceMappingURL=index.native.js.map
